export default {
    notify_00001: 'Notification',
    notify_00002: 'All notification',
    notify_00003: 'Year',
    notify_00004: 'Month',
  }